









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Toggle extends Vue {
  @Prop(Boolean) value!: boolean;

  click() {
    this.$emit('change', !this.value);
  }
}
